import { Component } from '@angular/core';
import { PromotionInfoBaseComponent } from '../promotion-info-base.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-promotion-info-pictogram',
  imports: [
    CommonModule
  ],
  templateUrl: './promotion-info-pictogram.component.html',
  styleUrls: [ './promotion-info-pictorgram.component.scss' ]
})
export class PromotionInfoPictogramComponent extends PromotionInfoBaseComponent { }
